/**
 * This file is auto-generated. Any modifications will be
 * overwritten by the generate-icon npm script.
 */
import React from 'react';
import { SvgIcon } from "../shared/SvgIcon";
var PhoneFillIcon = function PhoneFillIcon(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.61918 3.48776C7.15882 3.01918 6.4122 2.99212 5.91423 3.41452C3.94184 5.08752 2.76732 7.70122 3.77965 10.1702C4.55532 12.0619 5.84098 14.2841 7.87428 16.3537C10.0419 18.5601 12.3144 19.8348 14.1753 20.527C16.3151 21.3228 18.5143 20.3511 20.0561 18.7817L20.4898 18.3403C20.9676 17.854 20.9676 17.0745 20.4898 16.5882L17.8249 13.8757C17.3169 13.3586 16.477 13.3807 15.9968 13.9238L14.648 15.4492C14.4238 15.7027 14.072 15.7667 13.8016 15.6074C12.1525 14.6357 9.49143 12.502 8.45087 9.89875C8.35586 9.66107 8.42144 9.38049 8.61926 9.18163L10.059 7.73428C10.5419 7.24881 10.5443 6.46516 10.0644 5.9767L7.61918 3.48776Z"
  }));
};
export default PhoneFillIcon;